import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import React from 'react';
/**
 * _A caption for a table._
 *
 * ***
 *
 * `TableCaption` is used with the [`Table`](#/Lists%20%26%20Tables/Table) to provide accessible title for the table.
 * It renders `<caption>` element.
 *
 * Additional props will be forwarded to the wrapping `<caption>` element.
 */
const TableCaption = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement("caption", props, children);
};
TableCaption.displayName = 'TableCaption';
export default TableCaption;